var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "rightBo", staticClass: "right-body", attrs: { id: "rightBo" } },
    [
      _c(
        "div",
        {
          ref: "rightMiddle",
          class: _vm.searchResultShow ? "right-middle-search" : "right-middle",
          on: {
            contextmenu: function($event) {
              $event.preventDefault()
              return _vm.preventMenu($event)
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.searchResultShow,
                  expression: "!searchResultShow"
                }
              ],
              ref: "navigation",
              attrs: { id: "navigation" }
            },
            [
              _c("div", { staticClass: "navigation-path" }, [
                _c("table", [
                  _c("tr", [
                    _c("td", {
                      staticClass: "home-page-icon home-icon-position",
                      on: {
                        click: function($event) {
                          return _vm.toHomePage()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("td", {
                      staticClass:
                        "icon-util separate_icon separate-icon-position"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { float: "left", "line-height": "18Px" },
                        attrs: { id: "pathDiv" }
                      },
                      _vm._l(_vm.pathJson, function(path, index) {
                        return _c("span", { key: index }, [
                          index
                            ? _c("td", {
                                staticClass:
                                  "icon-util separate_icon separate-icon-position",
                                attrs: { id: index }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: {
                                "text-bold": index == _vm.pathJson.length - 1,
                                "name-desc-one": index == 0,
                                "name-desc":
                                  _vm.pathJson.length != 0 &&
                                  index != _vm.pathJson.length - 1 &&
                                  _vm.pathJson.length > 1 &&
                                  path.id != "addEllipsis",
                                "add-Ellipsis": path.id == "addEllipsis"
                              },
                              attrs: { title: path.name },
                              on: {
                                click: function($event) {
                                  return _vm.comeBackFile($event, path, index)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm._f("ellipsisNavi")(path.name)))]
                          )
                        ])
                      }),
                      0
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu-bar",
              class: [_vm.searchResultShow ? "menu-bar-search" : ""]
            },
            [
              _vm.showMenuButton()
                ? _c("div", { ref: "menuButton", staticClass: "menu-button" }, [
                    !_vm.recycleBinShow
                      ? _c("div", { staticStyle: { position: "relative" } }, [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showCopyTo(),
                                  expression: "showCopyTo()"
                                }
                              ],
                              staticClass: "single-button button-border-left",
                              style: { width: _vm.getWidth() },
                              on: { click: _vm.copyToDialogShow }
                            },
                            [
                              _c("div", { staticClass: "button-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "button-center-position ",
                                    style: { width: _vm.getTextWidth(1) }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "more-white-position copy-to icon-position"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cloud-exploer-operating"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("language.common.copyTo")
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.selectItemArr[0].dir &&
                                    _vm.selectItemArr.length == 1,
                                  expression:
                                    "!selectItemArr[0].dir && selectItemArr.length == 1"
                                }
                              ],
                              staticClass: "single-button button-border",
                              style: { width: _vm.getWidth() },
                              on: {
                                mouseover: function($event) {
                                  return _vm.addActive($event)
                                },
                                mouseout: function($event) {
                                  return _vm.removeActive($event)
                                },
                                click: function($event) {
                                  return _vm.downLoadFile()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "button-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "button-center-position ",
                                    style: { width: _vm.getTextWidth(2) }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "more-white-position down-load icon-position"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cloud-exploer-operating"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("language.common.download")
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showShareMenu(),
                                  expression: "showShareMenu()"
                                }
                              ],
                              staticClass:
                                "single-button button-border button-more",
                              style: { width: _vm.getWidth() },
                              on: {
                                mouseover: function($event) {
                                  return _vm.addActive($event)
                                },
                                mouseout: function($event) {
                                  return _vm.removeActive($event)
                                },
                                click: _vm.topShareMenuShow,
                                blur: function($event) {
                                  _vm.shareChooseShow = false
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "button-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "button-center-position ",
                                    style: { width: _vm.getTextWidth(13) }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "more-white-position icon-util share icon-position"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cloud-exploer-operating"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("language.common.share")
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "share-position",
                                      class: _vm.shareChooseShow
                                        ? "arrow-on"
                                        : "arrow-down",
                                      staticStyle: { top: "8px" }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.shareChooseShow
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "more-items-choose",
                                      staticStyle: {
                                        "min-width": "200px",
                                        width: "max-content"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "more-item-choose",
                                          on: { click: _vm.shareDialgOpen }
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "share item-position preview-position"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "menu-txt" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.common.shareWith"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "more-item-choose",
                                          on: {
                                            click: function($event) {
                                              return _vm.openShareTransfer()
                                            }
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "share-transfer item-position preview-position"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "menu-txt" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.common.shareTransfer"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showCutMenu(),
                                  expression: "showCutMenu()"
                                }
                              ],
                              staticClass: "single-button button-border",
                              style: { width: _vm.getWidth() },
                              on: {
                                mouseover: function($event) {
                                  return _vm.addActive($event)
                                },
                                mouseout: function($event) {
                                  return _vm.removeActive($event)
                                },
                                click: function($event) {
                                  return _vm.cutFile()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "button-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "button-center-position",
                                    style: { width: _vm.getTextWidth(3) }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "more-white-position cut icon-position"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cloud-exploer-operating "
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("language.common.cut"))
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showDeleteMenu()
                            ? _c(
                                "button",
                                {
                                  staticClass: "single-button button-border",
                                  style: { width: _vm.getWidth() },
                                  on: {
                                    mouseover: function($event) {
                                      return _vm.addActive($event)
                                    },
                                    mouseout: function($event) {
                                      return _vm.removeActive($event)
                                    },
                                    click: function($event) {
                                      return _vm.deleteDialogOpen()
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "button-content" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "button-center-position",
                                        style: { width: _vm.getTextWidth(4) }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "more-white-position delete icon-position"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cloud-exploer-operating"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("language.common.delete")
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.moreShow
                            ? _c("div", { staticStyle: { float: "left" } }, [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          !_vm.selectItemArr[0].dir &&
                                          _vm.selectItemArr.length == 1,
                                        expression:
                                          "!selectItemArr[0].dir && selectItemArr.length == 1"
                                      }
                                    ],
                                    staticClass: "single-button button-border",
                                    style: { width: _vm.getWidth() },
                                    on: {
                                      mouseover: function($event) {
                                        return _vm.addActive($event)
                                      },
                                      mouseout: function($event) {
                                        return _vm.removeActive($event)
                                      },
                                      click: function($event) {
                                        return _vm.previewPageShow()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "button-content" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "button-center-position",
                                            style: {
                                              width: _vm.getTextWidth(8)
                                            }
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "more-white-position preview icon-position"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cloud-exploer-operating"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.common.preview"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.suffixArr.includes("multcloud") &&
                                _vm.isAllEqual(_vm.suffixArr)
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "single-button button-border",
                                        style: { width: _vm.getWidth() },
                                        on: {
                                          mouseover: function($event) {
                                            return _vm.addActive($event)
                                          },
                                          mouseout: function($event) {
                                            return _vm.removeActive($event)
                                          },
                                          click: function($event) {
                                            return _vm.decryptPopupShow()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "button-content" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "button-center-position",
                                                style: {
                                                  width: _vm.getTextWidth(9)
                                                }
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "more-white-position encrypt icon-position"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cloud-exploer-operating"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "language.common.decrypt"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showRenameMenu()
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "single-button button-border",
                                        style: { width: _vm.getWidth() },
                                        on: {
                                          mouseover: function($event) {
                                            return _vm.addActive($event)
                                          },
                                          mouseout: function($event) {
                                            return _vm.removeActive($event)
                                          },
                                          click: _vm.editName
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "button-content" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "button-center-position",
                                                style: {
                                                  width: _vm.getTextWidth(10)
                                                }
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "more-white-position rename icon-position"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cloud-exploer-operating"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "language.common.rename"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showCopy(),
                                        expression: "showCopy()"
                                      }
                                    ],
                                    staticClass: "single-button  button-border",
                                    class: _vm.notSupportGoSite.includes(
                                      this.$route.query.cloudType
                                    )
                                      ? "button-border-right"
                                      : "",
                                    style: { width: _vm.getWidth() },
                                    on: {
                                      mouseover: function($event) {
                                        return _vm.addActive($event)
                                      },
                                      mouseout: function($event) {
                                        return _vm.removeActive($event)
                                      },
                                      click: function($event) {
                                        return _vm.copyFile()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "button-content" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "button-center-position",
                                            style: {
                                              width: _vm.getTextWidth(11)
                                            }
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "more-white-position copy icon-position"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cloud-exploer-operating"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.common.copy"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.notSupportGoSite.includes(
                                  this.$route.query.cloudType
                                ) && this.isSiteRootOrChild()
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "single-button",
                                        class: [
                                          !_vm.notSupportGoSite.includes(
                                            this.$route.query.cloudType
                                          )
                                            ? "button-border-right"
                                            : "",
                                          _vm.showCopy()
                                            ? "button-border"
                                            : "button-border-left"
                                        ],
                                        style: { width: _vm.getWidth() },
                                        on: {
                                          mouseover: function($event) {
                                            return _vm.addActive($event)
                                          },
                                          mouseout: function($event) {
                                            return _vm.removeActive($event)
                                          },
                                          click: function($event) {
                                            return _vm.goOfficialSite()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "button-content" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "button-center-position",
                                                style: {
                                                  width: _vm.getTextWidth(12)
                                                }
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "more-white-position to-site icon-position"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cloud-exploer-operating"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "language.common.toOfficialSite"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.moreShow
                            ? _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "clickoutside",
                                      rawName: "v-clickoutside",
                                      value: _vm.moreChooseClose,
                                      expression: "moreChooseClose"
                                    }
                                  ],
                                  staticClass:
                                    "single-button  button-border button-more button-border-right",
                                  style: { width: _vm.getWidth() },
                                  on: {
                                    mouseover: function($event) {
                                      return _vm.addActive($event)
                                    },
                                    mouseout: function($event) {
                                      return _vm.removeActive($event)
                                    },
                                    click: _vm.topRightMenuShow
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "button-content " },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "button-center-position",
                                          style: { width: _vm.getTextWidth(5) }
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "more-white-position more more-position"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cloud-exploer-more"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("language.common.more")
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.moreChooseShow
                                    ? _c(
                                        "div",
                                        { staticClass: "more-items-choose" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.selectIsFile &&
                                                    _vm.selectItemArr.length ==
                                                      1,
                                                  expression:
                                                    "selectIsFile && selectItemArr.length == 1"
                                                }
                                              ],
                                              staticClass: "more-item-choose",
                                              on: {
                                                click: function($event) {
                                                  return _vm.previewPageShow()
                                                }
                                              }
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "icon-util preview item-position"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "menu-txt" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.common.preview"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.showShareMenu(),
                                                  expression: "showShareMenu()"
                                                }
                                              ],
                                              staticClass: "more-item-choose",
                                              on: { click: _vm.shareDialgOpen }
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "share item-position preview-position"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "menu-txt" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.common.share"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.suffixArr.includes("multcloud") &&
                                          _vm.isAllEqual(_vm.suffixArr)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "more-item-choose",
                                                  attrs: { id: "sec" }
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "icon-util item-position encrypt"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "menu-txt" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.common.decrypt"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showRenameMenu()
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "more-item-choose",
                                                  on: { click: _vm.editName }
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "icon-util item-position rename"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "menu-txt" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.common.rename"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showTeamMenu()
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "more-item-choose",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.copyFile()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "icon-util item-position copy"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "menu-txt" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.common.copy"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.notSupportGoSite.includes(
                                            this.$route.query.cloudType
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "more-item-choose",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goOfficialSite()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "icon-util item-position to-site"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "menu-txt" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "language.common.toOfficialSite"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.recycleBinShow
                      ? _c("div", [
                          _c(
                            "button",
                            {
                              staticClass: "single-button more-botton-css",
                              style: { width: _vm.getTrashWidth() },
                              on: {
                                click: function($event) {
                                  return _vm.deleteDialogOpen()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "button-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "button-center-position",
                                    style: { width: _vm.getTextWidth(6) }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "icon-util  delete icon-position",
                                      staticStyle: {
                                        top: "3Px",
                                        "margin-right": "5Px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cloud-exploer-operating"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudExploer.deleteForever"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "single-button button-border button-border-right",
                              style: { width: _vm.getTrashWidth() },
                              on: {
                                mouseover: function($event) {
                                  return _vm.addActive($event)
                                },
                                mouseout: function($event) {
                                  return _vm.removeActive($event)
                                },
                                click: function($event) {
                                  return _vm.RestoreFile()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "button-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "button-center-position",
                                    style: { width: _vm.getTextWidth(7) }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "icon-util to-site icon-position",
                                      staticStyle: {
                                        "margin-right": "4Px",
                                        top: "3Px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cloud-exploer-operating"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudExploer.restore"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.searchResultShow,
                      expression: "searchResultShow"
                    }
                  ]
                },
                [
                  _c("span", [
                    _c(
                      "td",
                      {
                        staticClass: "search-back",
                        staticStyle: { "line-height": "20px" },
                        on: {
                          click: function($event) {
                            return _vm.backSearch()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("language.cloudExploer.back")) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", {
                    staticClass:
                      "icon-util separate_icon separate_icon-position"
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _c(
                      "td",
                      {
                        staticClass: "text-bold",
                        staticStyle: { "line-height": "20px" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("language.cloudExploer.searchResult")
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.itemButtonShow()
                ? _c(
                    "div",
                    {
                      staticClass: "item-button",
                      class: _vm.isflage ? "" : "right-body-disable"
                    },
                    [
                      !_vm.recycleBinShow &&
                      _vm.$route.query.folderId != "recycle_bin"
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "clickoutside",
                                    rawName: "v-clickoutside",
                                    value: _vm.handleSelectClose,
                                    expression: "handleSelectClose"
                                  }
                                ],
                                staticStyle: {
                                  float: "left",
                                  position: "relative"
                                },
                                on: {
                                  mouseover: function($event) {
                                    _vm.uploadFileItemShow = true
                                  },
                                  mouseleave: function($event) {
                                    _vm.uploadFileItemShow = false
                                  }
                                }
                              },
                              [
                                _vm.showUploadFile()
                                  ? _c("div", { staticClass: "upload-file" }, [
                                      _c("div", {
                                        staticClass: "upload",
                                        staticStyle: { float: "left" }
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        ref: "uploadFile",
                                        attrs: {
                                          type: "file",
                                          id: "openFile",
                                          multiple: "multiple"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.clickUploadFileChange(
                                              $event
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          class: [
                                            _vm.onlyShowRemote
                                              ? "upload-item"
                                              : "upload-item-dis"
                                          ],
                                          on: { click: _vm.openFileDialog }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "language.cloudExploer.uploadFile"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.onlyShowRemote()
                                        ? _c("div", {
                                            staticClass:
                                              "icon-util dropdown-position",
                                            class: _vm.dropDownName,
                                            on: { click: _vm.dropDownValueShow }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showUploadFile() &&
                                      !_vm.onlyShowRemote()
                                        ? _c("div", {
                                            staticStyle: {
                                              width: "12px",
                                              float: "left"
                                            }
                                          })
                                        : _vm._e()
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.onlyShowRemote() && !_vm.showUploadFile()
                                  ? _c("div", { staticClass: "upload-file" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "folder-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.linkTaskOpen()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("language.common.btLink")
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.uploadFileItemShow &&
                                          _vm.onlyShowRemote() &&
                                          _vm.showUploadFile(),
                                        expression:
                                          "uploadFileItemShow && onlyShowRemote() && showUploadFile()"
                                      }
                                    ],
                                    staticClass: "upload-file-items-choose"
                                  },
                                  [
                                    _c("input", {
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        type: "file",
                                        id: "openFolder",
                                        webkitdirectory: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "upload-file-item-choose",
                                        attrs: {
                                          title: _vm.$t(
                                            "language.common.btLink"
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.linkTaskOpen()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("language.common.btLink")
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showAddMorePhotos(_vm.nowTableData)
                              ? _c("div", { staticClass: "add-more-photos" }, [
                                  _c("div", {
                                    staticClass: "add-more-photos-icon"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.addMorePhotos()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.cloudExploerPopup.googlePhotosV2AddMore"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showNewAlbum()
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "new-folder",
                                    staticStyle: { "border-left": "0px" }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "plus-album add-plus-position",
                                      staticStyle: {
                                        float: "left",
                                        "margin-right": "5Px",
                                        position: "relative",
                                        top: "3Px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class: _vm.isflage
                                          ? "folder-item"
                                          : "folder-item-not",
                                        on: {
                                          click: function($event) {
                                            return _vm.newAlbum()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudExploer.newAlbum"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showNewFolder()
                              ? _c("div", { staticClass: "new-folder" }, [
                                  _c("div", {
                                    staticClass: "plus add-plus-position",
                                    staticStyle: {
                                      float: "left",
                                      "margin-right": "5Px",
                                      position: "relative",
                                      top: "3Px"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      class: _vm.isflage
                                        ? "folder-item"
                                        : "folder-item-not",
                                      on: {
                                        click: function($event) {
                                          return _vm.newFolder()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.cloudExploer.newFolder"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showNewBucket()
                              ? _c("div", {}, [
                                  _c("div", {
                                    staticClass: "bucket add-plus-position",
                                    staticStyle: {
                                      float: "left",
                                      "margin-right": "5Px",
                                      position: "relative",
                                      top: "3Px"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      class: _vm.isflage
                                        ? "folder-item"
                                        : "folder-item-not",
                                      on: {
                                        click: function($event) {
                                          return _vm.newFolder()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.cloudExploer.newBucket"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            (_vm.$store.state.copyArr.length ||
                              _vm.$store.state.cutClonArr.length) &&
                            _vm.showPasteMenu()
                              ? _c("div", { staticClass: "new-folder" }, [
                                  _c("div", {
                                    staticClass: " paste left-paste-position",
                                    staticStyle: { float: "left" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "folder-item up-paste-position  cloud-paste-position",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.pasteFile()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.paste"))
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.trashArr.includes(_vm.$route.query.cloudType)
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      _vm.$route.query.cloudType == "gSuite" &&
                                      _vm.$route.query.folderId == "/"
                                        ? "new-folder-dis"
                                        : "new-folder"
                                  },
                                  [
                                    _c("div", {
                                      staticClass: " delete",
                                      staticStyle: {
                                        float: "left",
                                        "margin-left": "3Px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "folder-item up-paste-position",
                                        staticStyle: { float: "left" },
                                        on: {
                                          click: function($event) {
                                            return _vm.goTrash()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudExploer.trash"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.recentlyDelArr.includes(
                              _vm.$route.query.cloudType
                            )
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      _vm.$route.query.cloudType ==
                                        "iCloudDrive" &&
                                      _vm.$route.query.folderId == "/"
                                        ? "new-folder-dis"
                                        : "new-folder"
                                  },
                                  [
                                    _c("div", {
                                      staticClass: " delete",
                                      staticStyle: {
                                        float: "left",
                                        "margin-left": "3Px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "folder-item up-paste-position",
                                        staticStyle: { float: "left" },
                                        on: {
                                          click: function($event) {
                                            return _vm.goTrash()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudExploer.recentlyDeleted"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showEmptyTrash()
                        ? _c("div", { staticClass: "upload-file" }, [
                            _c("div", {
                              staticClass: " delete",
                              staticStyle: { float: "left" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "folder-item up-paste-position",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.emptyTrash()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.cloudExploer.emptyTrash")
                                  )
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showDeleteAll()
                        ? _c("div", { staticClass: "upload-file" }, [
                            _c("div", {
                              staticClass: " delete",
                              staticStyle: { float: "left" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "folder-item up-paste-position",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteAll()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.cloudExploer.deleteAll")
                                  )
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRecoverAll()
                        ? _c("div", { staticClass: "upload-file" }, [
                            _c("div", {
                              staticClass: "icon-util to-site icon-position",
                              staticStyle: { "margin-right": "4Px", top: "3Px" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "folder-item up-paste-position",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.recoverAll()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.cloudExploer.recoverAll")
                                  )
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "operate-icons" }, [
                !_vm.searchResultShow
                  ? _c("div", {
                      staticClass:
                        " refresh cloud-exploer-refresh   refresh-position",
                      attrs: {
                        "data-title": _vm.$t("language.cloudExploer.reFresh")
                      },
                      on: {
                        click: function($event) {
                          return _vm.reFresh()
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listShow,
                      expression: "listShow"
                    }
                  ],
                  staticClass: " list refresh-position",
                  attrs: { "data-title": _vm.$t("language.cloudExploer.grid") },
                  on: {
                    click: function($event) {
                      return _vm.gridListShow()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.listShow,
                      expression: "!listShow"
                    }
                  ],
                  staticClass: "icon-util grid refresh-position",
                  attrs: {
                    "data-title": _vm.$t("language.cloudExploer.pageList")
                  },
                  on: {
                    click: function($event) {
                      return _vm.gridListShow()
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "clickoutside",
                        rawName: "v-clickoutside",
                        value: _vm.handleClose,
                        expression: "handleClose"
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.searching,
                        expression: "searching"
                      }
                    ],
                    staticClass: "icon-util search refresh-position",
                    attrs: {
                      "data-title": _vm.$t("language.cloudExploer.search"),
                      "element-loading-spinner": "el-icon-loading",
                      "element-loading-background": "#f2f7fe"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.searchPopupShow()
                      }
                    }
                  },
                  [
                    _c("searchDialog", {
                      ref: "searchDialog",
                      attrs: { id: "box" }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.searchResultShow ? "right-search-body" : "right-cont-body",
          on: {
            contextmenu: function($event) {
              $event.preventDefault()
              return _vm.preventMenu($event)
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.listShow,
                  expression: "listShow"
                }
              ],
              staticClass: "table-box",
              attrs: { id: "dropTableBox" },
              on: {
                contextmenu: function($event) {
                  $event.preventDefault()
                  return _vm.rightBlankMenuOpen($event)
                }
              }
            },
            [
              _c("div", { attrs: { id: "tableBoxTitle" } }, [
                _c(
                  "table",
                  {
                    staticStyle: { width: "100%", height: "auto" },
                    attrs: { border: "0", cellpadding: "0", cellspacing: "0" }
                  },
                  [
                    _c("tr", { staticClass: "table-th" }, [
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-oneDiv",
                          on: {
                            click: function($event) {
                              return _vm.upDownOrder(0)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              class: !_vm.searchResultShow
                                ? "tr-check-box"
                                : "tr-check-search",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.clickBoxAddAllTableToggle()
                                }
                              }
                            },
                            [
                              !_vm.searchResultShow
                                ? _c("div", {
                                    staticClass: "icon-util  icon-tr-position ",
                                    class:
                                      _vm.selectItemArr.length ==
                                        _vm.tableData.length &&
                                      _vm.selectItemArr.length > 0
                                        ? "check-small"
                                        : " nocheck-small"
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "th-span",
                              staticStyle: { "line-height": "40Px" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.fileName")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.index == 0
                            ? _c("div", {
                                staticClass: "icon-util narrow-position",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-twoDiv",
                          staticStyle: { "line-height": "40Px" },
                          on: {
                            click: function($event) {
                              return _vm.upDownOrder(1)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("language.common.size")))
                          ]),
                          _vm._v(" "),
                          _vm.index == 1
                            ? _c("div", {
                                staticClass: "icon-util narrow-position-two",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "cloud-td-twoDiv",
                          staticStyle: { "line-height": "40Px" },
                          on: {
                            click: function($event) {
                              return _vm.upDownOrder(2)
                            }
                          }
                        },
                        [
                          _vm.isShowSharedOn()
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.cloudExploer.sharedDate")
                                  )
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("language.common.dateModified"))
                                )
                              ]),
                          _vm._v(" "),
                          _vm.index == 2
                            ? _c("div", {
                                staticClass: "icon-util narrow-position-two",
                                class: _vm.upShow
                                  ? "file-up-narrow"
                                  : "file-down-narrow"
                              })
                            : _vm._e()
                        ]
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  ref: "boxStyle",
                  attrs: { id: "tableBox" }
                },
                [
                  _c(
                    "el-scrollbar",
                    { ref: "elscrollbar", staticStyle: { height: "100%" } },
                    [
                      _c(
                        "table",
                        {
                          directives: [
                            {
                              name: "infinite-scroll",
                              rawName: "v-infinite-scroll",
                              value: _vm.loadTableData,
                              expression: "loadTableData"
                            }
                          ],
                          staticStyle: {
                            width: "100%",
                            height: "auto",
                            "table-layout": "fixed"
                          },
                          attrs: {
                            border: "0",
                            cellpadding: "0",
                            "infinite-scroll-delay": "0",
                            "infinite-scroll-distance": "1",
                            cellspacing: "0"
                          }
                        },
                        [
                          _vm._l(_vm.nowTableData, function(item, index) {
                            return _c(
                              "tr",
                              {
                                key: index,
                                staticClass: "table-tr selectable",
                                class: [
                                  _vm.selectItemArr.includes(item)
                                    ? "tr-back-ground"
                                    : "",
                                  _vm.tableHoverItem == item
                                    ? "table-tr-hover"
                                    : ""
                                ],
                                on: {
                                  mouseout: function($event) {
                                    _vm.tableHoverItem = null
                                  },
                                  mouseover: function($event) {
                                    _vm.tableHoverItem = item
                                  },
                                  contextmenu: function($event) {
                                    $event.preventDefault()
                                    return _vm.clickRightMenuShow(
                                      $event,
                                      item,
                                      index
                                    )
                                  },
                                  dblclick: function($event) {
                                    $event.preventDefault()
                                    _vm.readyOpenFile(item),
                                      (_vm.rightMenuShow = false)
                                  },
                                  click: [
                                    function($event) {
                                      $event.stopPropagation()
                                      _vm.clickCheckSingleItem(
                                        item,
                                        index,
                                        $event
                                      ),
                                        _vm.closeAllMenu()
                                    },
                                    function($event) {
                                      if (!$event.shiftKey) {
                                        return null
                                      }
                                      return _vm.multipleBox(index)
                                    }
                                  ]
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    ref: "tdOne",
                                    refInFor: true,
                                    staticClass: "cloud-td-oneDiv"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class: !_vm.searchResultShow
                                          ? "tr-check-box"
                                          : "tr-check-search",
                                        on: {
                                          dblclick: function($event) {
                                            $event.stopPropagation()
                                          },
                                          click: [
                                            function($event) {
                                              $event.stopPropagation()
                                              if (
                                                $event.ctrlKey ||
                                                $event.shiftKey ||
                                                $event.altKey ||
                                                $event.metaKey
                                              ) {
                                                return null
                                              }
                                              return _vm.clickBoxAddTableCheck(
                                                item,
                                                index
                                              )
                                            },
                                            function($event) {
                                              if (!$event.shiftKey) {
                                                return null
                                              }
                                              return _vm.multipleBox(index)
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c("div", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.searchResultShow,
                                              expression: "!searchResultShow"
                                            }
                                          ],
                                          staticClass:
                                            "icon-util icon-tr-position",
                                          class: _vm.selectItemArr.includes(
                                            item
                                          )
                                            ? "check-small "
                                            : "nocheck-small "
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.$route.query.cloudType !=
                                              "baiDu" ||
                                            (_vm.$route.query.cloudType ==
                                              "baiDu" &&
                                              !_vm.baiDuReadOnlyArr.includes(
                                                _vm.$route.query.folderId
                                              ) &&
                                              !_vm.baiDuReadOnlyNameArr.includes(
                                                item.name
                                              )),
                                          expression:
                                            "$route.query.cloudType != 'baiDu' || ($route.query.cloudType == 'baiDu' && !baiDuReadOnlyArr.includes($route.query.folderId) && !baiDuReadOnlyNameArr.includes(item.name))"
                                        }
                                      ],
                                      staticClass:
                                        "small-file tr-file-position",
                                      class: item.dir
                                        ? _vm.matchfolderType(item.docType)
                                        : _vm.matchfileType(item.name)
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.$route.query.cloudType ==
                                              "baiDu" &&
                                            (_vm.baiDuReadOnlyArr.includes(
                                              _vm.$route.query.folderId
                                            ) ||
                                              _vm.baiDuReadOnlyNameArr.includes(
                                                item.name
                                              )),
                                          expression:
                                            "($route.query.cloudType == 'baiDu' && (baiDuReadOnlyArr.includes($route.query.folderId) || baiDuReadOnlyNameArr.includes(item.name)))"
                                        }
                                      ],
                                      staticClass:
                                        "small-file tr-file-position",
                                      class: item.dir
                                        ? _vm.matchfolderType(item.docType) +
                                          "-not"
                                        : _vm.matchfileType(item.name)
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class: !_vm.searchResultShow
                                          ? "cloud-file-name"
                                          : "cloud-file-name-not",
                                        attrs: { id: "fileName" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            ref: "listName",
                                            refInFor: true,
                                            staticClass: "name-edit-div",
                                            attrs: { title: item.name },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                _vm.readyOpenFile(item),
                                                  _vm.closeAllMenu()
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            ref: "listInputName",
                                            refInFor: true,
                                            class: _vm.isflage
                                              ? "cloud-outclass"
                                              : "cloud-outclass-not"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: item.inputValue,
                                                  expression: "item.inputValue"
                                                }
                                              ],
                                              staticClass: "name-edit-input",
                                              domProps: {
                                                value: item.inputValue
                                              },
                                              on: {
                                                focus: _vm.onfocusEvent,
                                                blur: function($event) {
                                                  return _vm.submitName(
                                                    item,
                                                    index
                                                  )
                                                },
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return $event.target.blur(
                                                    $event
                                                  )
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    item,
                                                    "inputValue",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "cloud_edit_icon"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "icon-util name-sure",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.submitName(
                                                        item,
                                                        index
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "icon-util name-cancel name-cancel-position",
                                                  on: {
                                                    mousedown: function(
                                                      $event
                                                    ) {
                                                      $event.stopPropagation()
                                                      return _vm.cancelEditName(
                                                        item,
                                                        index
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "cloud-td-twoDiv" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm._f("formatByte")(item.size)) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "cloud-td-twoDiv" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("transferTime")(item.modifiedTime)
                                    )
                                  )
                                ])
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.listPageLoading
                            ? _c("div", { staticClass: "load-tr" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.cloudExploer.loading")
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.noMore
                            ? _c("div", { staticClass: "load-tr" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.cloudExploer.dataLoaded")
                                  )
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isShowGooglePhotosV2NotSelect(_vm.nowTableData)
                    ? _c("div", { staticClass: "exploer-notice-two" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.cloudExploerPopup.googlePhotosV2NotSelect"
                            )
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.emptyNoticeShow &&
                  _vm.$route.query.folderId != "recycle_bin" &&
                  !_vm.searchResultShow
                    ? _c("div", { staticClass: "exploer-notice" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("language.cloudExploer.emptyNotice")
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.emptyNoticeShow &&
                  _vm.$route.query.folderId == "recycle_bin"
                    ? _c("div", { staticClass: "exploer-notice" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("language.cloudExploer.trashEmpty")) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.emptyNoticeShow && _vm.searchResultShow
                    ? _c("div", { staticClass: "exploer-notice" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("language.cloudExploer.searchEmpty")
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.listShow,
                  expression: "!listShow"
                },
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "gridBox",
              staticClass: "grid-list",
              attrs: { id: "gridList" },
              on: {
                contextmenu: function($event) {
                  $event.preventDefault()
                  return _vm.rightBlankMenuOpen($event)
                }
              }
            },
            [
              _c("div", { staticClass: "grid-title" }, [
                _c(
                  "div",
                  {
                    staticClass: "cloud-td-oneDiv",
                    on: {
                      click: function($event) {
                        return _vm.upDownOrder(0)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        class: !_vm.searchResultShow
                          ? "tr-check-box"
                          : "tr-check-search",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.clickBoxAddAllTableToggle()
                          }
                        }
                      },
                      [
                        !_vm.searchResultShow
                          ? _c("div", {
                              staticClass: "icon-util  icon-tr-position ",
                              class:
                                _vm.selectItemArr.length ==
                                  _vm.tableData.length &&
                                _vm.selectItemArr.length > 0
                                  ? "check-small"
                                  : " nocheck-small"
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "th-span",
                        staticStyle: { "line-height": "40Px" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.common.fileName")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.index == 0
                      ? _c("div", {
                          staticClass: "icon-util narrow-position",
                          class: _vm.upShow
                            ? "file-up-narrow"
                            : "file-down-narrow"
                        })
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cloud-td-twoDiv",
                    staticStyle: { "line-height": "40Px" },
                    on: {
                      click: function($event) {
                        return _vm.upDownOrder(1)
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.common.size")))
                    ]),
                    _vm._v(" "),
                    _vm.index == 1
                      ? _c("div", {
                          staticClass: "icon-util narrow-position-two",
                          class: _vm.upShow
                            ? "file-up-narrow"
                            : "file-down-narrow"
                        })
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cloud-td-twoDiv",
                    staticStyle: { "line-height": "40Px" },
                    on: {
                      click: function($event) {
                        return _vm.upDownOrder(2)
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.common.dateModified")))
                    ]),
                    _vm._v(" "),
                    _vm.index == 2
                      ? _c("div", {
                          staticClass: "icon-util narrow-position-two",
                          class: _vm.upShow
                            ? "file-up-narrow"
                            : "file-down-narrow"
                        })
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { id: "fileGrid" } },
                [
                  _c(
                    "el-scrollbar",
                    { ref: "elscrollbarList", staticStyle: { height: "100%" } },
                    [
                      _c(
                        "table",
                        {
                          directives: [
                            {
                              name: "infinite-scroll",
                              rawName: "v-infinite-scroll",
                              value: _vm.loadTableData,
                              expression: "loadTableData"
                            }
                          ],
                          attrs: {
                            "infinite-scroll-delay": "0",
                            "infinite-scroll-distance": "1"
                          }
                        },
                        _vm._l(_vm.nowTableData, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "grid-lattice",
                              on: {
                                contextmenu: function($event) {
                                  $event.preventDefault()
                                  return _vm.clickRightMenuShow($event, item)
                                },
                                click: function($event) {
                                  return _vm.readyOpenFile(item)
                                },
                                mouseover: function($event) {
                                  ;(_vm.gridHoverIndex = index),
                                    (_vm.tableHoverItem = item)
                                },
                                mouseout: function($event) {
                                  ;(_vm.gridHoverIndex = -1),
                                    (_vm.tableHoverItem = null)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "grid-all",
                                  class: [
                                    _vm.gridHoverIndex == index ||
                                    _vm.selectItemArr.includes(item)
                                      ? "grid-hover"
                                      : ""
                                  ]
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        height: "25Px",
                                        width: "25Px",
                                        "z-index": "7",
                                        position: "absolute"
                                      },
                                      on: {
                                        click: [
                                          function($event) {
                                            $event.stopPropagation()
                                            return _vm.addTableCheck(
                                              item,
                                              index
                                            )
                                          },
                                          function($event) {
                                            if (!$event.shiftKey) {
                                              return null
                                            }
                                            return _vm.multipleBox(index)
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c("div", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.gridHoverIndex == index ||
                                              _vm.selectItemArr.includes(item),
                                            expression:
                                              "gridHoverIndex == index || selectItemArr.includes(item)"
                                          }
                                        ],
                                        staticClass:
                                          "icon-util  grid-icon-positon",
                                        class: [
                                          _vm.selectItemArr.includes(item)
                                            ? "check-small"
                                            : "nocheck-small"
                                        ],
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.addTableCheck(
                                              item,
                                              index
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "grid-position",
                                      class: [
                                        item.dir
                                          ? "grid-position"
                                          : "grid-position-top"
                                      ]
                                    },
                                    [
                                      _vm.$route.query.cloudType != "baiDu" ||
                                      (_vm.$route.query.cloudType == "baiDu" &&
                                        !_vm.baiDuReadOnlyArr.includes(
                                          _vm.$route.query.folderId
                                        ) &&
                                        !_vm.baiDuReadOnlyNameArr.includes(
                                          item.name
                                        ))
                                        ? _c("div", {
                                            staticClass: "large-file-type ",
                                            class: item.dir
                                              ? "large-" +
                                                _vm.matchfolderType(
                                                  item.docType
                                                ) +
                                                " large-folder-position"
                                              : "large-" +
                                                _vm.matchfileType(item.name)
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.$route.query.cloudType == "baiDu" &&
                                      (_vm.baiDuReadOnlyArr.includes(
                                        _vm.$route.query.folderId
                                      ) ||
                                        _vm.baiDuReadOnlyNameArr.includes(
                                          item.name
                                        ))
                                        ? _c("div", {
                                            staticClass: "large-file-type",
                                            class: item.dir
                                              ? "large-" +
                                                _vm.matchfolderType(
                                                  item.docType
                                                ) +
                                                "-not"
                                              : "large-" +
                                                _vm.matchfileType(item.name) +
                                                "-not"
                                          })
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class: !_vm.searchResultShow
                                        ? "grid-name"
                                        : "grid-name-not",
                                      on: {
                                        mouseover: function($event) {
                                          $event.stopPropagation()
                                          _vm.gridHoverIndex = -1
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          ref: "gridName",
                                          refInFor: true,
                                          staticClass: "grid-name-children",
                                          attrs: { title: item.name }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "gridInputName",
                                          refInFor: true,
                                          class: _vm.isflage
                                            ? "grid-outclass"
                                            : "grid-outclass-not"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.inputValue,
                                                expression: "item.inputValue"
                                              }
                                            ],
                                            staticClass: "grid-edit-input",
                                            domProps: {
                                              value: item.inputValue
                                            },
                                            on: {
                                              focus: _vm.onfocusEvent,
                                              blur: function($event) {
                                                return _vm.submitName(
                                                  item,
                                                  index
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return $event.target.blur(
                                                  $event
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  item,
                                                  "inputValue",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "grid_edit_icon" },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "icon-util grid-name-sure",
                                                staticStyle: { float: "left" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.submitName(
                                                      item,
                                                      index
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "icon-util grid-name-cancel",
                                                staticStyle: { float: "left" },
                                                on: {
                                                  mousedown: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.cancelEditName(
                                                      item,
                                                      index
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "grid-name-txt" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("transferFilesTime")(
                                          item.modifiedTime
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.listPageLoading
                    ? _c("div", { staticClass: "load-tr-grid" }, [
                        _vm._v(_vm._s(_vm.$t("language.cloudExploer.loading")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.noMore
                    ? _c("div", { staticClass: "load-tr-grid" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.cloudExploer.dataLoaded"))
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.emptyNoticeShow
                    ? _c("div", { staticClass: "exploer-notice-two" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.cloudExploer.emptyNotice"))
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.rightBlankMenuShow
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "clickoutside",
                      rawName: "v-clickoutside",
                      value: _vm.rightBlankMenuClose,
                      expression: "rightBlankMenuClose"
                    }
                  ],
                  staticClass: "blank-menus-choose",
                  attrs: { id: "rightBlankMenu" }
                },
                [
                  _vm.showUploadFile()
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: { click: _vm.openFileDialog }
                        },
                        [
                          _c("input", {
                            ref: "uploadFile",
                            staticStyle: { display: "none" },
                            attrs: { type: "file", id: "openFile" }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "preview-position item-position upload"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.cloudExploer.uploadFile"))
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showNewFolder()
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.newFolder()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "preview-position plus item-position"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "menu-txt",
                              staticStyle: { "margin-left": "1Px" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.cloudExploer.newFolder")
                                )
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showNewBucket()
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.newFolder()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "preview-position bucket item-position"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "menu-txt",
                              staticStyle: { "margin-left": "1Px" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.cloudExploer.newBucket")
                                )
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.onlyShowRemote()
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.linkTaskOpen()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "preview-position remote item-position",
                            staticStyle: {
                              top: "6Px !important",
                              "margin-right": "16Px !important"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.btLinkTask")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.$store.state.copyArr.length ||
                    _vm.$store.state.cutClonArr.length) &&
                  _vm.$route.query.folderId != "recycle_bin" &&
                  _vm.showPasteMenu()
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.pasteFile()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "preview-position item-position paste",
                            staticStyle: { "margin-left": "3Px" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.paste")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.trashArr.includes(_vm.$route.query.cloudType) &&
                  _vm.$route.query.folderId != "recycle_bin"
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.goTrash()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "preview-position item-position delete",
                            staticStyle: { "margin-left": "1Px" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.cloudExploer.trash"))
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recentlyDelArr.includes(_vm.$route.query.cloudType) &&
                  _vm.$route.query.folderId != "recycle_bin"
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.goTrash()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "preview-position item-position delete",
                            staticStyle: { "margin-left": "1Px" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.cloudExploer.recentlyDeleted")
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.query.folderId == "recycle_bin" &&
                  _vm.$route.query.cloudType == "google_drive"
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.emptyTrash()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "preview-position item-position delete"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.cloudExploer.emptyTrash"))
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.query.folderId == "recycle_bin" &&
                  _vm.$route.query.cloudType == "iCloudDrive"
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.deleteAll()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "preview-position item-position delete"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.cloudExploer.deleteAll"))
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.query.folderId == "recycle_bin" &&
                  _vm.$route.query.cloudType == "iCloudDrive"
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.recoverAll()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "preview-position item-position to-site"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.cloudExploer.recoverAll"))
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSelectRightMenu()
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "clickoutside",
                      rawName: "v-clickoutside",
                      value: _vm.rightMenuClose,
                      expression: "rightMenuClose"
                    }
                  ],
                  staticClass: "right-menus-choose",
                  attrs: { id: "rightMenu" }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.selectIsFile && _vm.selectItemArr.length == 1,
                          expression:
                            "selectIsFile && selectItemArr.length == 1"
                        }
                      ],
                      staticClass: "more-item-choose",
                      on: {
                        click: function($event) {
                          return _vm.previewPageShow()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "preview preview-position item-position"
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu-txt" }, [
                        _vm._v(_vm._s(_vm.$t("language.common.preview")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.selectIsFile && _vm.selectItemArr.length == 1,
                          expression:
                            "selectIsFile && selectItemArr.length == 1"
                        }
                      ],
                      staticClass: "more-item-choose",
                      on: {
                        click: function($event) {
                          return _vm.downLoadFile()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "down-load item-position preview-position"
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu-txt" }, [
                        _vm._v(_vm._s(_vm.$t("language.common.download")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showShareMenu(),
                          expression: "showShareMenu()"
                        }
                      ],
                      staticClass: "more-item-choose",
                      on: {
                        mouseenter: function($event) {
                          _vm.shareRightMenuShow = true
                        },
                        mouseleave: function($event) {
                          _vm.shareRightMenuShow = false
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "share item-position preview-position"
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu-txt" }, [
                        _vm._v(_vm._s(_vm.$t("language.common.share")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "arrow-right share-position" }),
                      _vm._v(" "),
                      _vm.shareRightMenuShow
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "clickoutside",
                                  rawName: "v-clickoutside",
                                  value: _vm.rightMenuClose,
                                  expression: "rightMenuClose"
                                }
                              ],
                              staticClass: "right-menus-choose",
                              staticStyle: { left: "100%" },
                              attrs: { id: "shareRightMenu" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.selectItemArr.length == 1,
                                      expression: "selectItemArr.length == 1"
                                    }
                                  ],
                                  staticClass: "more-item-choose",
                                  on: {
                                    click: function($event) {
                                      return _vm.shareDialgOpen()
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "share item-position preview-position"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "menu-txt" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.common.shareWith")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.selectItemArr.length == 1,
                                      expression: "selectItemArr.length == 1"
                                    }
                                  ],
                                  staticClass: "more-item-choose",
                                  on: {
                                    click: function($event) {
                                      return _vm.openShareTransfer()
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "share-transfer item-position preview-position"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "menu-txt" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.common.shareTransfer")
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.suffixArr.includes("multcloud") &&
                  _vm.isAllEqual(_vm.suffixArr)
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          attrs: { id: "moreItem" },
                          on: {
                            click: function($event) {
                              return _vm.decryptPopupShow()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              " item-position encrypt preview-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.decrypt")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showTeamMenu()
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.copyToDialogShow()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "preview-position item-position copy-to"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.copyTo")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCutMenu()
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.cutFile()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "preview-position item-position cut"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.cut")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showTeamMenu()
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.copyFile()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "preview-position item-position copy"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.copy")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.$store.state.copyArr.length ||
                    _vm.$store.state.cutClonArr.length) &&
                  _vm.$route.query.folderId != "recycle_bin" &&
                  _vm.showPasteMenu()
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.pasteFile()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "preview-position item-position paste"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.paste")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.notSupportGoSite.includes(this.$route.query.cloudType)
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.goOfficialSite()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "preview-position item-position to-site"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.toOfficialSite"))
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showDeleteMenu()
                    ? _c(
                        "div",
                        {
                          staticClass: "more-item-choose",
                          on: {
                            click: function($event) {
                              return _vm.deleteDialogOpen()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "preview-position item-position delete"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-txt" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.delete")))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.searchMenuShow
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "clickoutside",
                      rawName: "v-clickoutside",
                      value: _vm.searchMenuClose,
                      expression: "searchMenuClose"
                    }
                  ],
                  staticClass: "right-menus-choose",
                  attrs: { id: "searchMenu" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "more-item-choose",
                      on: {
                        click: function($event) {
                          return _vm.jumpTo()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "preview-position item-position to-site"
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("language.cloudExploer.jumpTo")))
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.recycleMenuShow
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "clickoutside",
                      rawName: "v-clickoutside",
                      value: _vm.recycleMenuClose,
                      expression: "recycleMenuClose"
                    }
                  ],
                  staticClass: "right-menus-choose",
                  attrs: { id: "recycleMenu" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "more-item-choose",
                      on: {
                        click: function($event) {
                          return _vm.deleteDialogOpen()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "preview-position item-position delete"
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { float: "left" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.cloudExploer.deleteForever"))
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "more-item-choose",
                      on: {
                        click: function($event) {
                          return _vm.RestoreFile()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "preview-position item-position to-site"
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(_vm.$t("language.cloudExploer.restore")))
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.searchResultShow,
                  expression: "!searchResultShow"
                }
              ],
              staticClass: "selectInfo-footer"
            },
            [
              _c("div", { staticClass: "select-Info" }, [
                _vm._v(
                  _vm._s(_vm.selectItemArr.length) +
                    "/" +
                    _vm._s(_vm.tableData.length) +
                    " " +
                    _vm._s(_vm.$t("language.common.itemsSelected")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "select-Info" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatByte")(
                      _vm._f("getAllBytes")(_vm.selectItemArr)
                    )
                  ) +
                    "/" +
                    _vm._s(
                      _vm._f("formatByte")(_vm._f("getAllBytes")(_vm.tableData))
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.snapTaskIconShow,
                      expression: "snapTaskIconShow"
                    }
                  ],
                  staticClass: "icon scaling-open scaling-open-position",
                  on: {
                    click: function($event) {
                      return _vm.snapTasksOpen()
                    }
                  }
                },
                [
                  _c("snapTaskDialog", {
                    ref: "snapTaskDialog",
                    on: {
                      cancel: function($event) {
                        return _vm.cancelUpload($event)
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("googlePhotosV2CreateDialog", {
        ref: "googlePhotosV2CreateDialog",
        attrs: { items: _vm.nowTableData },
        on: { createFolder: _vm.handleCreateFolderGooglePhotos }
      }),
      _vm._v(" "),
      _c("googlePhotosV2TipsDialog", { ref: "googlePhotosV2TipsDialog" }),
      _vm._v(" "),
      _c("deleteDialog", { ref: "deleteDialog" }),
      _vm._v(" "),
      _c("shareDialog", { ref: "shareDialog" }),
      _vm._v(" "),
      _c("copyToDialog", { ref: "copyToDialog" }),
      _vm._v(" "),
      _c("detailedProgrssDialog", { ref: "detailedProgrss" }),
      _vm._v(" "),
      _c("retryFailedDialog", { ref: "retryFailedDialog" }),
      _vm._v(" "),
      _c("linkTaskDialog", { ref: "linkTaskDialog" }),
      _vm._v(" "),
      _c("uploadToTreeDialog", { ref: "uploadToTreeDialog" }),
      _vm._v(" "),
      _c("fileExistDialog", { ref: "fileExistDialog" }),
      _vm._v(" "),
      _c("cancelAllDialog", { ref: "cancelAllDialog" }),
      _vm._v(" "),
      _c("upgradeVipDialog", { ref: "upgradeVipDialog" }),
      _vm._v(" "),
      _c("upgradeNewDialog", { ref: "upgradeNewDialog" }),
      _vm._v(" "),
      _c("decryptDialog", { ref: "decryptDialog" }),
      _vm._v(" "),
      _c("parseTipsDialog", { ref: "parseTipsDialog" }),
      _vm._v(" "),
      _c("subfileSelectDialog", { ref: "subfileSelectDialog" }),
      _vm._v(" "),
      _c("remindBindEmailDialog", { ref: "remindBindEmailDialog" }),
      _vm._v(" "),
      _c("emailPasteDialog", { ref: "emailPasteDialog" }),
      _vm._v(" "),
      _c("userStarPopup", { ref: "userStarPopup" }),
      _vm._v(" "),
      _c("userStarJumpPopup", { ref: "userStarJumpPopup" }),
      _vm._v(" "),
      _c("userStarFeedbackPopup", { ref: "userStarFeedbackPopup" }),
      _vm._v(" "),
      _c("onedriveBusinesFolderError", { ref: "onedriveBusinesFolderError" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88d7e2ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88d7e2ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/cloud_exploer.vue
// module id = null
// module chunks = 